import { toast } from "react-toastify";

const GenericError = () => {
  toast.error("Something went wrong. Please try again later.", {
    position: "top-right",
  });
};

export default GenericError